// Extracts parameter value for input key present in the current page path.
const extractQueryParamFromPageLocation = (key: string): string => {
  try {
    // Modern approach using URLSearchParams
    const urlParams = new URLSearchParams(window.location.search)
    const value = urlParams.get(key)
    return value ?? ''
  } catch (error) {
    // Fallback to original implementation
    /* eslint-disable i18next/no-literal-string */
    const queryParamValue = window.location.search.replace(
      // eslint-disable-next-line no-useless-escape
      new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'),
      '$1',
    )

    const isEncoded = /%[0-9A-F]{2}/i.test(queryParamValue)
    /* eslint-enable i18next/no-literal-string */

    return isEncoded ? decodeURIComponent(queryParamValue) : queryParamValue
  }
}

export default extractQueryParamFromPageLocation
